import { getExecutingEnvironment } from "@app/resolveModule/env";
import t from "@ext/localization/locale/translate";
import type { ConfirmOptions } from "@ui-kit/ConfirmPopover";

const Description = ({ text }: { text: string }) => (
	<span
		dangerouslySetInnerHTML={{
			// biome-ignore lint/style/useNamingConvention: expected
			__html: text,
		}}
	/>
);

export const itemDeleteConfirm = (title: string, count: number): ConfirmOptions => {
	const isSection = count > 0;
	const description = isSection
		? t("article.actions.delete.section.body").replace("{{title}}", title).replace("{{count}}", `(${count})`)
		: t("article.actions.delete.article.body").replace("{{title}}", title);
	const trashNote = getExecutingEnvironment() === "tauri" ? ` ${t("article.actions.delete.restore-from-trash")}` : "";

	return {
		title: isSection ? t("article.actions.delete.section.title") : t("article.actions.delete.article.title"),
		description: <Description text={`${description}${trashNote}`} />,
		cancelText: t("article.actions.delete.buttons.secondary"),
		confirmText: t("article.actions.delete.buttons.primary").replace(
			"{{count}}",
			isSection ? ` (${count + 1})` : "",
		),
		status: "error",
		icon: "triangle-alert",
	};
};
